import React from "react";

const AboutNew = () => {
  
  return (
    <section className="topics" id="about">
      <div className="container">
        <div className="card topic-card">
          <div className="card-content">
            <h2
              className="headline headline-2 section-title card-title"
              id="topic-label"
            >
              About
            </h2>

            <p className="card-text">
            <p>Greetings! I'm <strong>Disha</strong>, a dedicated Full Stack Web Developer blending a passion for innovation with a collaborative spirit. My coding journey started with the allure of Data Structures and Algorithms, igniting a fascination for problem-solving and logical thinking. Proficient in <strong>React</strong>, <strong>JavaScript</strong> ,<strong>HTML5</strong>, <strong>CSS3</strong>, <strong>Node.js</strong> ,  <strong>Python-Flask</strong> ,<strong>TypeScript</strong> and  <strong>Vue.js</strong> , I specialize in crafting dynamic and user-centric web applications.</p>

<p>In the ever-evolving realm of technology, I remain committed to ceaseless learning, growth, and embracing the leading edge of web development trends. Collaborating, learning, and creating alongside fellow developers and innovators is what fuels my enthusiasm. Together, let's harness the power of code to construct a dynamic and interconnected digital world.</p>
<br />
             <b><i>   Let's connect and
              create exceptional digital experiences together {"  "}<span className="wave"> ..</span> </i></b>
            </p>
          </div>
      
        </div>
      </div>
    </section>
  );
};

export default AboutNew;
